import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]

  activate(event) {
    if (event.currentTarget.dataset.turboFrame === "_top") return

    this.tabTargets.forEach((tab) => {
      tab.classList.remove("astral-tab--active")
      tab.removeAttribute("aria-current")
    })

    event.currentTarget.classList.add("astral-tab--active")
    event.currentTarget.setAttribute("aria-current", "page")
  }
}
